import axios from "axios";
const config = require('@/config')
const statistics = {
    state: () => ({
        all: {},
        theRestaurant: null,
        loading: false,
        selectedRestaurant: '',
        selectedDate: null
    }),
    getters: {
        STATISTICS(state) {return state.all},
        STATISTICS_ITEM(state) {return state.theRestaurant},
        STATISTICS_LOADING(state) {return state.loading},
        SELECTED_RESTAURANT(state) {return state.selectedRestaurant},
        SELECTED_DATE(state) {return state.selectedDate},
    },
    mutations: {
        setStatistics(state, data) {
            state.all[data.id] = data.statistic
        },
        setStatisticsItem(state, payload) {
            state.theRestaurant = payload
        },
        setLoading(state, payload) {
            state.loading = payload
        },
        setSelectedRestaurant(state, payload) {
            state.selectedRestaurant = payload
        },
        setSelectedDate(state, payload) {
            state.selectedDate = payload
        },
    },
    actions: {
        async getStatistics({commit, dispatch, rootState}, id) {
            await dispatch('tryAutoSignIn', null, { root: true })
            commit('setLoading', true)
            let idToken = rootState.tokens.idToken
            let axiosHeader = { headers: {"Authorization": idToken, "Content-Type": 'application/json'} }
            await axios.get(`${config.servUrl}admin/statistics/restaurant/${id}/orders`, axiosHeader)
                .then(response => {
                    let statistic = response.data
                    commit('setStatistics', {id, statistic})
                    commit('setLoading', false)
                })
                .catch(error => {
                    console.log(error);
                    dispatch('addNewNotice', {text: error, error: true})
                    commit('setLoading', false)
                })
        },
        async getStatisticsItem({commit, dispatch, rootState}, data) {
            await dispatch('tryAutoSignIn', null, { root: true })
            commit('setLoading', true)
            let idToken = rootState.tokens.idToken
            let requestConfig = {
                headers: {"Authorization": idToken, "Content-Type": 'application/json'},
                params: data.dates
            }
            axios.get(`${config.servUrl}admin/statistics/restaurant/${data.id}/orders`, requestConfig)
                .then(response => {
                    commit('setStatisticsItem', response.data)
                    commit('setLoading', false)
                })
                .catch(error => {
                    console.log(error);
                    dispatch('addNewNotice', {text: error, error: true})
                    commit('setLoading', false)
                })
        }
    },
}
export {statistics}
